import { PortfolioPosition } from 'portfolio/PortfolioSelection';
import { NumberFormat } from '@instinet-analytics/core-lib';

const MAX_PILL_COUNT = 2;

export function getValidPills(pills: string[]) {
    const truncated = (
        pills.length <= MAX_PILL_COUNT ? pills : pills.slice(0, MAX_PILL_COUNT)
    ).map((x, i) => (i === 0 ? x.toUpperCase() : x));

    switch (truncated.length) {
        case 1:
            return isSymbolValid(truncated[0]) ? truncated : [];
        case 2: {
            const symbolValid = isSymbolValid(truncated[0]);
            const qtyValid = isQuantityValid(truncated[1]);
            return symbolValid ? (qtyValid ? truncated : [truncated[0]]) : [];
        }
        default:
            return truncated;
    }
}

export function getSanitisedPills(validPills: string[]) {
    const symbol = validPills[0].trim();
    if (symbol === '') {
        return [];
    }

    return [symbol, ...validPills.slice(1)];
}

const sharesText = ' shares';

export function getFormattedPills(pills: string[], numberFormat: NumberFormat) {
    switch (pills.length) {
        case 2:
            return [pills[0], numberFormat.n0(parseInt(pills[1])) + sharesText];
        default:
            return pills;
    }
}

export function getPortfolioPosition(
    pills: string[]
): PortfolioPosition | undefined {
    const qty = pills.length > 1 ? parseInt(pills[1]) : 1;
    const absQty = Math.abs(qty);
    const side = qty >= 0 ? 'B' : 'S';
    return pills.length > 0
        ? {
              symbol: pills[0],
              qty: absQty,
              side,
              qtyRemaining: absQty,
          }
        : undefined;
}

export function formatInputText(inputText: string, confirmedPillCount: number) {
    switch (confirmedPillCount) {
        case 0:
            return (
                isSymbolValid(inputText)
                    ? inputText
                    : inputText.replace(/[^A-Z0-9./ ]/gi, '')
            ).toUpperCase();
        case 1:
            return isQuantityValid(inputText)
                ? inputText
                : inputText === '0'
                ? ''
                : inputText.startsWith('-')
                ? '-' + inputText.substring(1).replace(/\D/g, '')
                : inputText.replace(/\D/g, '');
        default:
            return '';
    }
}

function containsNumericChars(text: string) {
    return text.match(/^[0-9]+$/g) !== null;
}

function isSymbolValid(symbol: string) {
    return !!symbol && !symbol.toLowerCase().endsWith(sharesText);
}

function isQuantityValid(quantity: string) {
    let toVerify = quantity.endsWith(sharesText)
        ? quantity.split(' ')[0].replace(',', '') // assumes default NumberFormat locale
        : quantity;

    toVerify = toVerify.startsWith('-') ? toVerify.substring(1) : toVerify;

    const parsedValue = parseInt(toVerify);
    return (
        containsNumericChars(toVerify) &&
        Number.isInteger(parsedValue) &&
        parsedValue !== 0
    );
}
